/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integration: NonNullable<unknown> }} Rights_Tools_All_Connections_TitleInputs */



/**
* | output |
* | --- |
* | "Applies to every {integration} connection" |
*
* @param {Rights_Tools_All_Connections_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_all_connections_title = /** @type {((inputs: Rights_Tools_All_Connections_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_All_Connections_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gilt für jede ${i?.integration}-Verbindung`)
	return /** @type {LocalizedString} */ (`Applies to every ${i?.integration} connection`)
});